export interface LoginRequest {
  email: string;
  password: string;
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  token: string;
  newPassword: string;
}

export interface RegisterRequest {
  email: string;
  password: string;
  role: UserRole;
  nome?: string;
  cpf?: string;
  telefone?: string;
  rua?: string;
  numero?: string;
  bairro?: string;
  cep?: string;
  cidade?: string;
  estado?: string;
}

export interface RegisterResponse {
  message: string;
}

export interface EmployeeRecord {
  id: number;
  email: string;
  role: string;
  nome: string;
  cpf?: string | null;
  telefone?: string;
  rua?: string;
  numero?: string;
  bairro?: string;
  cep?: string;
  cidade?: string;
  estado?: string;
  ativo?: boolean;
}

export interface UpdateUserRequest {
  nome: string;
  email: string;
  cpf?: string;
  telefone?: string;
  rua?: string;
  numero?: string;
  bairro?: string;
  cep?: string;
  cidade?: string;
  estado?: string;
  role: string;
  password?: string;
}

export interface LoginResponse {
  /** Token JWT retornado pelo backend. O frontend nao armazena mais este token
   *  localmente (cookies httpOnly sao usados em seu lugar). Mantido para
   *  compatibilidade com a interface de resposta da API. */
  token: string;
  role: string;
  email: string;
  nome?: string;
}

export interface User {
  email: string;
  role: string;
  nome?: string;
}

export enum UserRole {
  MASTER = 'MASTER',
  ADMIN = 'ADMIN',
  TECNICO = 'TECNICO',
}
